import React, { FC, useEffect, useState, useCallback } from "react";
import {
    ISummary,
    IDam,
    IStateOfKnowledge,
    IDamsList,
    ISummaryCriticalHazards, ITag, ITagEntry, IInvestigation,
    ISummaryControlMeasureAdequacy,
    ISummaryControlMeasureAssessment,
    ISummarySOK,
    ILikelihood,
    IHarmSummary,
    ICostSummary,
    ISocietalRisk

} from "../types/types";
import { get } from "../fetchers/fetchers";
import BarChart from "../components/dashboard/bar";
import Map from "../components/dashboard/map";
import Alert from '@material-ui/lab/Alert';
import Typography from "@material-ui/core/Typography";
import MoreVertIcon from "@material-ui/icons/MoreVert";
import SettingsIcon from "@material-ui/icons/Settings";
import ViewModuleIcon from "@material-ui/icons/ViewModule";
import AccountCircleIcon from "@material-ui/icons/AccountCircle";
import { ExitToApp, ExpandMore } from "@material-ui/icons";
import { makeStyles } from '@material-ui/core/styles';
import Filter from "../components/dashboard/filter";
import { useHistory } from "react-router-dom";
import {
    Accordion,
    AccordionSummary, ClickAwayListener,
    Divider, Grow, IconButton, MenuItem, Drawer,
    Paper, Popper, Toolbar, Grid, Tooltip
} from "@material-ui/core";


import { useParams } from "react-router";
import StateOfKnowledge from "../components/dashboard/state_of_knowledge";
import CriticalHazardsSummary from "../components/dashboard/critical_hazards_summary";
import ControlMeasures from "../components/dashboard/control_measures";
import Summary from "../components/dashboard/summary_table";
import LikelihoodSummary from "../components/dashboard/likelihood";
import Loading from "../components/dashboard/loading";
import InvestigationSummary from "../components/dashboard/summary_investigations";
import { API_URL } from "../env";

const { REACT_APP_BRANCH } = process.env;


interface IRouteParams {
    id: string
}

interface IDashboardProps {
}



const drawerWidth = 300;

const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
    },
    drawer: {
        width: drawerWidth,
        flexShrink: 0,
        padding: 50

    },
    drawerPaper: {
        width: drawerWidth,
        padding: 10
    },
    // necessary for content to be below app bar
    toolbar: theme.mixins.toolbar,
    content: {
        flexGrow: 1,
        backgroundColor: theme.palette.background.default,
        padding: theme.spacing(3),
    },
    nested: {
        paddingLeft: theme.spacing(4),
        fontSize: '1rem',
    },
    nestedHeadings: {
        fontWeight: 600,
    }
}));


const Dashboard: FC<IDashboardProps> = () => {
    const history = useHistory();
    const classes = useStyles();

    const [isLoaded, setIsLoaded] = useState<boolean>(false);
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [dams, setDams] = useState<IDam[]>([]);
    const [summary, setSummary] = useState<ISummary>();
    const [stateOfKnowledge, SetStateOfKnowledge] = useState<IStateOfKnowledge[]>([]);
    const [stateOfKnowledgeFiltered, setStateOfKnowledgeFiltered] = useState<IStateOfKnowledge[]>([]);
    const [criticalHazards, setCriticalHazards] = useState<ISummaryCriticalHazards[]>([]);
    const [activeAssessments, setActiveAssessments] = useState<number[]>([]);
    const [controlMeasureAdequacy, setControlMeasureAdequacy] = useState<ISummaryControlMeasureAdequacy[]>([]);
    const [controlMeasureAssessment, setControlMeasureAssessment] = useState<ISummaryControlMeasureAssessment[]>([]);
    const [sokSummary, setSokSummary] = useState<ISummarySOK[]>([]);
    const [likelihood, setLikelihood] = useState<ILikelihood[]>([]);
    const [harmSummary, setHarmSummary] = useState<IHarmSummary[]>([]);
    const [costSummary, setCostSummary] = useState<ICostSummary[]>([]);

    const [riskSummary, setRiskSummary] = useState<ISocietalRisk[]>([]);




    const [damList, setDamList] = useState<IDamsList[]>([]);
    const [damListFiltered, setDamListFiltered] = useState<IDamsList[]>([]);


    const [popperOpen, setPopperOpen] = useState<boolean>(false);
    const [anchorEl, setAnchorEl] = React.useState<HTMLButtonElement | null>(null);

    const [dialogOpen, setDialogOpen] = useState<boolean>(false);

    const [tags, setTags] = useState<ITag[]>([]);
    const [tagEntries, setTagEntries] = useState<ITagEntry[]>([]);
    const [investigations, setInvestigations] = useState<IInvestigation[]>([]);

    const params = useParams<IRouteParams>()

    const getSummary = async () => {
        const d = await get<ISummary>(API_URL + "summary/" + params.id)
        setSummary(d);
    }

    const getDams = async () => {
        const d = await get<IDam[]>(API_URL + "dams/" + params.id);
        setDams(d)
    }

    const getStateOfKnowledge = async () => {
        const d = await get<IStateOfKnowledge[]>(API_URL + "summary/state-of-knowledge/" + params.id);
        SetStateOfKnowledge(d)
    }


    const getDamList = async () => {
        const d = await get<IDamsList[]>(API_URL + "summary/assessment-projects/" + params.id);
        setDamList(d)
    }

    const getCriticalHazards = async () => {
        const d = await get<ISummaryCriticalHazards[]>(API_URL + "summary/critical-hazard-assessment/" + params.id);
        setCriticalHazards(d)
    }

    const getControlMeasureAdequacy = async () => {
        const d = await get<ISummaryControlMeasureAdequacy[]>(API_URL + "summary/control-measures-adequacy/" + params.id);
        setControlMeasureAdequacy(d)
    }

    const getControlMeasureAssessment = async () => {
        const d = await get<ISummaryControlMeasureAssessment[]>(API_URL + "summary/control-measures-assessment/" + params.id);
        setControlMeasureAssessment(d)
    }

    const getSOKsummary = async () => {
        const d = await get<ISummarySOK[]>(API_URL + "summary/state-of-knowledge-summary/" + params.id);
        setSokSummary(d)
    }

    const getLikelihood = async () => {
        const d = await get<ILikelihood[]>(API_URL + "summary/likelihood/" + params.id);
        setLikelihood(d)
    }

    const getHarm = async () => {
        const d = await get<IHarmSummary[]>(API_URL + "summary/consequence-category/" + params.id);
        setHarmSummary(d)
    }


    const getCost = async () => {
        const d = await get<ICostSummary[]>(API_URL + "summary/control-measures-costs/" + params.id);
        setCostSummary(d)
    }

    const getRisk = async () => {
        const d = await get<ISocietalRisk[]>(API_URL + "summary/societal-risk-before/" + params.id);
        setRiskSummary(d)
    }



    const getTags = async () => {
        const d = await get<ITag[]>(API_URL + "tag");
        setTags(d)
    }
    const getTagEntries = async () => {
        const d = await get<ITagEntry[]>(API_URL + "tag/entry");
        setTagEntries(d)
    }

    const getInvestigations = async () => {
        const d = await get<IInvestigation[]>(API_URL + "summary/investigations/" + params.id);
        setInvestigations(d)
    }

    const getData = async () => {
        setIsLoading(true);
        await Promise.all([getSummary(),
        getDams(),
        getStateOfKnowledge(),
        getRisk(),
        getCost(),
        getHarm(),
        getLikelihood(),
        getSOKsummary(),
        getControlMeasureAssessment(),
        getControlMeasureAdequacy(),
        getCriticalHazards(),
        getDamList(), getInvestigations(),
        getTags(),
        getTagEntries()]);
        setIsLoaded(true);
        setIsLoading(false);
    }


    useEffect(() => {
        if (!isLoaded && !isLoading) {
            getData();
        }
    }, [isLoaded, isLoading])


    const setFilter = (assessments: number[], damfilter: IDamsList[]) => {
        setActiveAssessments(assessments);
        setDamListFiltered(damfilter)

        // setStateOfKnowledgeFiltered(filter)

    }

    const renderOverview = (index: number, template_group_name: string) => {
        return (
            <Accordion expanded={true}>
                <AccordionSummary id={index.toString()} expandIcon={<ExpandMore />}>
                    <Typography variant="h6"> {template_group_name} </Typography>
                </AccordionSummary>
                <Typography>
                    {isLoaded &&
                        <Grid item xs={12} sm={12} md={12} lg={12}>
                            <Map dams={damListFiltered} />
                        </Grid>}
                </Typography>
            </Accordion>
        )
    }


    const renderStateOfKnowledge = (index: number, template_group_name: string) => {
        return (
            <>
                {isLoaded && <StateOfKnowledge stateOfKnowledge={stateOfKnowledge} sokSummary={sokSummary} damList={damList} assessments_filtered={activeAssessments} risk_assessments={riskSummary} />}
            </>
        )
    }

    const renderCriticalHazards = (index: number, template_group_name: string) => {
        return (
            <>
                {isLoaded && <CriticalHazardsSummary criticalHazards={criticalHazards} damList={damList} assessments_filtered={activeAssessments} risk_assessments={riskSummary}/>}
            </>
        )
    }

    const renderControlMeasures = (index: number, template_group_name: string) => {
        return (
            <>
                {isLoaded && <ControlMeasures controlMeasures={controlMeasureAdequacy} controlMeasureAssessments={controlMeasureAssessment} damList={damList} assessments_filtered={activeAssessments} risk_assessments={riskSummary} />}
            </>
        )
    }

    const renderSummary = (index: number, template_group_name: string) => {
        return (
            <>
                {isLoaded && <Summary sokSummary={sokSummary} risk_assessments={riskSummary} harm={harmSummary} likelihood={likelihood} damList={damList} assessments_filtered={activeAssessments} criticalHazards={criticalHazards} controlMeasures={controlMeasureAdequacy} costAssessment={costSummary} controlMeasureAssessments={controlMeasureAssessment} />}
            </>
        )
    }

    const renderLikelihood = (index: number, template_group_name: string) => {
        return (
            <>
                {isLoaded && <LikelihoodSummary harm={harmSummary} likelihood={likelihood} assessments_filtered={activeAssessments} damList={damList}  />}
            </>
        )
    }
    const renderInvestigations = (index: number, template_group_name: string) => {
        return (
            <>
                {isLoaded && <InvestigationSummary tags={tags}  tag_entries={tagEntries} investigations={investigations} assessments_filtered={activeAssessments} damList={damList}  risk_assessments={riskSummary}/>}
            </>
        )
    }



    const renderNavMenu = () => {
        return <Popper
            style={{ zIndex: 100 }}
            open={popperOpen}
            anchorEl={anchorEl}

            placement={"bottom-end"} disablePortal transition>
            {({ TransitionProps }) => (
                <Grow {...TransitionProps}>
                    <Paper>
                        <ClickAwayListener onClickAway={_ => setPopperOpen(false)}>
                            <div>
                                {/*<MenuItem onClick={_=>getFile()}><CloudDownloadIcon style={{marginLeft:"-10px", paddingRight:"10px"}}/>Download</MenuItem>*/}
                                <MenuItem ><SettingsIcon style={{ marginLeft: "-10px", paddingRight: "10px" }} />Settings</MenuItem>
                                <MenuItem onClick={_ => history.push('/dams/1')}><ViewModuleIcon style={{ marginLeft: "-10px", paddingRight: "10px" }} />View all dams</MenuItem>
                                <MenuItem><AccountCircleIcon style={{ marginLeft: "-10px", paddingRight: "10px" }} />Account</MenuItem>
                                <MenuItem onClick={_ => handleLogout()}><ExitToApp style={{ marginLeft: "-10px", paddingRight: "10px" }} />Logout</MenuItem>
                            </div>
                        </ClickAwayListener>
                    </Paper>
                </Grow>)}
        </Popper>
    }


    const handleLogout = () => {
        localStorage.removeItem("token");
        localStorage.removeItem("username");
        history.push('/');
        window.location.reload();
    };


    if (!isLoaded) {
        return <div style={{ height: "100vh", display: 'flex', alignItems: 'center', justifyContent: 'center' }}><h1><Loading data={isLoaded} /></h1></div>
    }

    return (<>

        <Toolbar style={{ backgroundColor: "#19b0ef", height: "68px", color: "white" }}>

            <Typography variant={"h5"}
                style={{ paddingTop: "7px", paddingBottom: "7px" }}>
                SFAIRP | Dashboard
            </Typography>

            <div style={{ position: "fixed", right: "310px", marginTop: "-3px", }}>
                <Tooltip title="Menu" placement={'bottom-end'}>
                    <IconButton color="inherit" onClick={(e) => {
                        setPopperOpen(!popperOpen);
                        setAnchorEl(e.currentTarget)
                    }

                    }><MoreVertIcon /></IconButton>
                </Tooltip>
            </div>
            {renderNavMenu()}

        </Toolbar>
        {REACT_APP_BRANCH !== 'main' ? <Alert variant="filled" severity="warning">
            This is a development version, the data displayed may not be accurate and updates to the data will not be stored.
        </Alert> : null}

        <div className={classes.root}>


            <Paper className={classes.content} variant={"outlined"}
                style={{ display: "flex", flexDirection: "column", height: "100%", margin: "10px", flex: 1 }}>
                <Typography variant="h5" component="h2" style={{ backgroundColor: "#969697", color: "white" }}>
                    Overview
                </Typography>

                {renderOverview(13, "Location")}

                <Typography variant="h5" component="h2" style={{ backgroundColor: "#969697", color: "white" }}>
                    State of Knowledge
                </Typography>

                {renderStateOfKnowledge(12, "Summary")}

                <Typography variant="h5" component="h2" style={{ backgroundColor: "#969697", color: "white" }}>
                    Investigations
                </Typography>

                {renderInvestigations(12, "Summary")}

                <Typography variant="h5" component="h2" style={{ backgroundColor: "#969697", color: "white" }}>
                Confidence Hazards below Safety Threshold
                </Typography>

                {renderCriticalHazards(12, "Summary")}

                <Typography variant="h5" component="h2" style={{ backgroundColor: "#969697", color: "white" }}>
                    Control measures
                </Typography>

                {renderControlMeasures(12, 'Summary')}

                <Typography variant="h5" component="h2" style={{ backgroundColor: "#969697", color: "white" }}>
                    Likelihood and harm
                </Typography>

                {renderLikelihood(12, "Summary")}

                <Typography variant="h5" component="h2" style={{ backgroundColor: "#969697", color: "white" }}>
                    Overall summary
                </Typography>

                {renderSummary(12, "Summary")}

            </Paper>

            <Drawer variant="permanent" className={classes.drawer} classes={{
                paper: classes.drawerPaper,
            }} anchor='right'>

                <Filter damList={damList} stateOfKnowledge={stateOfKnowledge} returnFunction={setFilter} />

            </Drawer>

        </div>

    </>
    )


}

export default Dashboard;
